import React from "react";
import { slide as Menu } from "react-burger-menu";
import { Link, animateScroll as scroll } from "react-scroll";

var styles = {
  bmBurgerButton: {
    position: "fixed",
    width: "36px",
    height: "30px",
    left: "36px",
    top: "36px",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 5px 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: "25px",
  },
  bmItem: {
    display: "inline-block",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

export class MenuComponent extends React.Component {
  showSettings(event: any) {
    event.preventDefault();
  }

  render() {
    return (
      <Menu styles={styles}>
        {/*@ts-ignore*/}
        {this.props.elems.map((elem) => (
          <Link
            key={elem.id}
            activeClass="active"
            to={elem.id}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
          >
            {elem.name}
          </Link>
        ))}
      </Menu>
    );
  }
}
